var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Om7Sense as p } from "../Om7Sense.js";
import { useCallback, useEffect, useRef, useState } from "react";
var doesPathContainWildcard = function (path) { return path.indexOf('*') !== -1 || path.indexOf('+') !== -1; };
var getPathWithoutTrailingPlus = function (path) { return path.replace('/+', ''); };
/**
 * Subscribe to updates to the DS on a certain path. The push subscription
 * needs to be set up already for this to work.
 * @param path
 * @returns {OmData} the value of the DS path or undefined
 */
export var useDSSubscription = function (path) {
    var pathHasWildcard = doesPathContainWildcard(path);
    var pathToFetch = getPathWithoutTrailingPlus(path);
    var _a = useState(p.getPath(pathToFetch)), currentValue = _a[0], setCurrentValue = _a[1];
    var subToUnsubscribe = useRef();
    // TODO: once we update to React 18, we can migrate this to useSyncExternalStore
    var updateCallback = useCallback(function (value) {
        if (pathHasWildcard) {
            setCurrentValue(__assign({}, p.getPath(pathToFetch)));
        }
        else {
            setCurrentValue(__assign({}, value));
        }
    }, []);
    useEffect(function () {
        subToUnsubscribe.current = p.subscribeDS(path, updateCallback);
        return function () {
            p.unsubscribeDS(updateCallback, subToUnsubscribe.current);
        };
    }, [path, updateCallback]);
    return currentValue;
};
/**
 * Subscribe to updates to the push server on a certain path. This will set up both
 * push and DS subscriptions.
 * @param {String} path to subscribe to
 * @returns {OmData} current value in server-side Datastore
 */
export var usePushSubscription = function (path) {
    var _a = useState(), subscribeError = _a[0], setSubscribeError = _a[1];
    var _b = useState(), currentValue = _b[0], setCurrentValue = _b[1];
    var callToUnsubscribe = useRef();
    useEffect(function () {
        p.subscribe(path, function (value) {
            setCurrentValue(value);
        }, false).then(function (cbToUnsubscribe) {
            callToUnsubscribe.current = cbToUnsubscribe;
            // If we can resolve this path to one particular path we fetch it and set the initial value
            var pathWithoutTrailingWildcard = path.endsWith('/*') ? path.substring(0, path.length - 2) : path;
            if (!doesPathContainWildcard(pathWithoutTrailingWildcard)) {
                setCurrentValue(p.getPath(pathWithoutTrailingWildcard));
            }
        }).catch(function (error) {
            setSubscribeError(error);
        });
        return function () { var _a; return (_a = callToUnsubscribe.current) === null || _a === void 0 ? void 0 : _a.call(callToUnsubscribe); };
    }, [path, setSubscribeError, setCurrentValue, callToUnsubscribe]);
    return __assign(__assign({}, currentValue), { subscribeError: subscribeError });
};
